// This file takes shared resources
// and injects them as angular module parts.
// Not the best way to do things, but works for now.

angular.module('sharedservices', [])

  .factory('Dictionary', function(){
    return window.GlobalDictionary;
  })

  .factory('ActivityDictionary', function(){
    return window.ActivityDictionary;
  })

  .factory('HelperService', function(){
    return window.Helpers;
  })

  .factory('LoanFormParser', function(){
    return window.LoanFormParser;
  })

  .factory('Finance', function(){
    return window.finance;
  })

  .factory('FastClick', function(){
    return window.FastClick;
  });
